export default {
  PAY_AT_TABLE_SURVEY: 'PayAtTableSurvey',
  ORDER_AHEAD_SURVEY: 'OrderAheadSurvey',
  ORDER_AT_TABLE_SURVEY: 'OrderAtTableSurvey',
  ORDER_SURVEY: 'OrderSurvey',
  MOBILE_TIPPING_SURVEY: 'MobileTippingSurvey',
  TABLESIDE_SURVEY: 'TablesideSurvey',
  APP_RATING_SURVEY: 'AppRatingSurvey'
};
